import { render } from "./TwNavigation.vue?vue&type=template&id=71fc83c3"
import script from "./TwNavigation.vue?vue&type=script&lang=js"
export * from "./TwNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__